import { getElegivelCarrosselSubmarcasConfig } from '../../commons/elegibilidade-carrossel-sub-marcas/elegibilidade-carrossel-sub-marcas.config';

export const isCarrosselElegivel = (marca: string): boolean => {
  return getElegivelCarrosselSubmarcasConfig({ marca });
};
